export default __webpack_public_path__ + "static/media/ico-neptune-db-score-high.b56dbe31.svg";